const CATEGORIES = {
    PROGRAMMING_TECH: 10
};

const SUB_CATEGORIES = {
    VOICE_OVERS: 16,
    SOCIAL_MARKETING: 67,
    BUY_VIDEO_TESTIMONIALS: 101,
    RESUMES_COVER_LETTERS: 112,
    PROOFREADING: 114,
    WEB_MOBILE_DESIGN: 151,
    WHITEBOARD_EXPLAINER_VIDEOS: 228
};

export { CATEGORIES, SUB_CATEGORIES };